import React, { useRef, useState } from 'react';
import { Provider } from 'react-redux';

import Customization from 'src/containers/Modifiers/Customization';

import { ISiteItemCustomization } from '../hooks/useSiteItemCustomization';
import styles from '../berryChat.module.scss';

const noop = () => undefined;

interface Props {
  customization: ISiteItemCustomization;
}

/**
 * The item page's own "Customize" section (src/containers/Modifiers/
 * Customization → AddIngredients: Included Ingredients, Toppings, Dressing,
 * Greens, Proteins…), rendered inside Berry's picker against Berry's private
 * customization store. Cards, limits, "+$" labels and disabled states are the
 * site's; Berry only supplies the selection handler and shows the running
 * price.
 */
const SiteItemCustomizer: React.FC<Props> = ({ customization }) => {
  const autoScrollDivRef = useRef<HTMLDivElement>(null);
  const modifiersRef = useRef<any[]>([]);
  const cyoiRef = useRef(null);
  const [cyoiSelected, setCyoiSelected] = useState(false);
  const [itemAsModifierSelected, setItemAsModifierSelected] = useState({
    status: false,
    highLightArea: null as any,
  });

  return (
    <div className={styles.siteCustomizer} data-testid="berry-site-customizer">
      <Provider store={customization.store}>
        <Customization
          item={customization.item}
          showCustomizedOptions
          showCustomization={false}
          handleIngredientSelection={customization.select}
          autoScrollDivRef={autoScrollDivRef}
          firstTimeModal={false}
          itemAsModifierState={{ itemsAsModifier: [], setItemsAsModifier: noop }}
          isCreateYourOwnItem={false}
          CYOIScrollToMissingRequiredArea={{
            refToScrollToMissingRequiredArea: cyoiRef,
            isCYOIRequiredModifierSelected: cyoiSelected,
            setisCYOIRequiredModifierSelected: setCyoiSelected,
          }}
          itemsAsModifiersToHandleScroll={{
            refToScrollToMissingRequiredItemAsModifiers: [],
            isItemAsModifierSelected: itemAsModifierSelected,
            setIsItemAsModifierSelected: setItemAsModifierSelected,
          }}
          hideFirstTimeModal={noop}
          showFirstTimeModal={noop}
          modifiersRef={modifiersRef}
          dbId={null}
        />
      </Provider>
    </div>
  );
};

export default SiteItemCustomizer;
